var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlackColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.8125 6.5H5.8125H21.8125",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.8125 6.5V4.5C8.8125 3.96957 9.02321 3.46086 9.39829 3.08579C9.77336 2.71071 10.2821 2.5 10.8125 2.5H14.8125C15.3429 2.5 15.8516 2.71071 16.2267 3.08579C16.6018 3.46086 16.8125 3.96957 16.8125 4.5V6.5M19.8125 6.5V20.5C19.8125 21.0304 19.6018 21.5391 19.2267 21.9142C18.8516 22.2893 18.3429 22.5 17.8125 22.5H7.8125C7.28207 22.5 6.77336 22.2893 6.39829 21.9142C6.02321 21.5391 5.8125 21.0304 5.8125 20.5V6.5H19.8125Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.8125 11.5V17.5",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.8125 11.5V17.5",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlackColor);
export default __webpack_public_path__ + "static/media/DeleteBlackColor.6e0ed8cf1d0ddbf211643caa7edf8c6e.svg";
export { ForwardRef as ReactComponent };